import React from 'react';
import Layout from './layout';

const HealthRecordsPage = () => {
    return (
        <Layout>
        <div className="container mx-auto p-6">
            <h1 className="text-4xl font-bold mb-6">Health Records</h1>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <h2 className="text-3xl font-semibold mb-4">Your Medical History</h2>
                <p>View and manage your medical history, including past diagnoses, treatments, and medical notes.</p>
                {/* Add components or tables to display medical history */}

                <h2 className="text-3xl font-semibold mb-4 mt-6">Lab Results</h2>
                <p>Access your lab results, including blood tests, imaging reports, and other diagnostic tests.</p>
                {/* Add components to display lab results */}

                <h2 className="text-3xl font-semibold mb-4 mt-6">Treatment Plans</h2>
                <p>Review and manage your treatment plans as prescribed by your healthcare providers.</p>
                {/* Add components to display treatment plans */}
            </div>
        </div>
        </Layout>
    );
};

export default HealthRecordsPage;
